// @ts-nocheck
/* eslint-disable */
export const bookmarkIcon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.1021 1.01614C3.94094 1.01614 3 2.02731 3 3.27514V14.4626C3 14.6616 3.10511 14.8445 3.27027 14.9413C3.43544 15.0327 3.63564 15.0166 3.79079 14.8983L8 11.6281L12.2092 14.8929C12.3594 15.0058 12.5596 15.0273 12.7297 14.9305C12.8949 14.8337 13 14.6508 13 14.4465V3.25901C13 2.01117 12.0541 1 10.8979 1H5.09209L5.1021 1.01614Z" fill="currentColor"/></svg>`,
    name: 'bookmark' as const
};